import { render, staticRenderFns } from "./air-qual.vue?vue&type=template&id=70258d1f&scoped=true&"
import script from "./air-qual.vue?vue&type=script&lang=js&"
export * from "./air-qual.vue?vue&type=script&lang=js&"
import style0 from "./air-qual.vue?vue&type=style&index=0&id=70258d1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70258d1f",
  null
  
)

export default component.exports